import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Helmet} from "react-helmet";
import {Animated} from "react-animated-css";
import {fetchPortfolios} from '../actions/index';

class Portfolios extends Component{
  componentDidMount(){
    if(this.props.portfolios.length === 0){
      this.props.fetchPortfolios();
    }
  }
  render(){
    return (
      <Animated animationIn="fadeIn" className="container-fluid pt-4">
        <Helmet>
          <title>ผลงาน - GongIdeas | Let's imagine come true.</title>
        </Helmet>
        <h1 className="text-center">ผลงาน</h1>
        <div className="row">
          {this.props.portfolios.map((portfolio, index) => (
            <Animated animationIn="fadeInUp" animationInDelay={500+(index*100)} className="col-sm-6 col-md-4 col-lg-3 p-0" key={portfolio.portfolio_id}>
              <Link to={'/portfolio/'+portfolio.portfolio_id} className="portfolio-item">
                <img src={'https://www.gongideas.com/uploads/'+portfolio.image_url} alt="{portfolio.name}" className="w-100" />
                <div className="portfolio-name">
                  <div className="title">{portfolio.name}</div>
                  <div className="sub-title">{portfolio.type}</div>
                </div>
              </Link>
            </Animated>
          ))}
        </div>
      </Animated>
    );
  }
}
export default connect((state) => state, {fetchPortfolios})(Portfolios);


// WEBPACK FOOTER //
// ./src/components/Portfolios.js